module.exports = __webpack_public_path__ + "static/img/avatar-s-6.6b63817c.png";